export interface EnergyCostScenario {
  olderAnnualKwh: number
  newAnnualKwh: number
}

/** Existing state generated-column scenario; illustrative, not measured usage. */
export const STATE_ENERGY_COST_SCENARIO: Readonly<EnergyCostScenario> = {
  olderAnnualKwh: 1700,
  newAnnualKwh: 500,
}

/** Existing ZIP generated-column scenario; illustrative, not measured usage. */
export const ZIP_ENERGY_COST_SCENARIO: Readonly<EnergyCostScenario> = {
  olderAnnualKwh: 1500,
  newAnnualKwh: 450,
}

export function stateAnnualSavingsDollars(row: { rate_cents_kwh: number; annual_savings_cents: number }): number {
  const rate = Number(row.rate_cents_kwh)
  const cents = Number(row.annual_savings_cents)
  const { olderAnnualKwh, newAnnualKwh } = STATE_ENERGY_COST_SCENARIO
  if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(cents) || cents !== Math.round((olderAnnualKwh - newAnnualKwh) * rate)) {
    throw new Error('State energy savings do not match the displayed illustrative consumption model')
  }
  return cents / 100
}

export function productEnergyEstimate(annualKwh: number | null | undefined, rateCentsKwh: number, olderAnnualKwh = STATE_ENERGY_COST_SCENARIO.olderAnnualKwh): {
  annualCostDollars: number
  annualSavingsDollars: number
} | null {
  if (!Number.isFinite(annualKwh) || annualKwh! <= 0 || !Number.isFinite(rateCentsKwh) || rateCentsKwh <= 0 || !Number.isFinite(olderAnnualKwh) || olderAnnualKwh <= 0) return null
  const costCents = Math.round(annualKwh! * rateCentsKwh)
  return {
    annualCostDollars: costCents / 100,
    annualSavingsDollars: (Math.round(olderAnnualKwh * rateCentsKwh) - costCents) / 100,
  }
}

export function savingsScenarioText(annualSavings: number, scenario?: EnergyCostScenario): string {
  const amount = annualSavings.toLocaleString('en-US', { maximumFractionDigits: 2 })
  return scenario
    ? `At the displayed electricity rate, an illustrative comparison of ${scenario.olderAnnualKwh.toLocaleString('en-US')} versus ${scenario.newAnnualKwh.toLocaleString('en-US')} kWh per year gives estimated annual savings of $${amount}. Actual savings depend on both appliances and household usage.`
    : `Estimated annual upgrade savings are $${amount} under the supplied appliance-use assumptions. Actual savings depend on both appliances and household usage.`
}
